import { FileText, Search, Zap } from "lucide-react";

const benefits = [{
  icon: FileText,
  title: "Find PDFs Faster",
  description: "Get search results filtered exclusively to PDF files, saving you time from sorting through irrelevant content",
  gradient: "from-blue-500 to-cyan-500"
}, {
  icon: Search,
  title: "Yahoo! Search Power",
  description: "Leverage Yahoo!'s comprehensive search capabilities specifically optimized for finding PDF documents",
  gradient: "from-indigo-500 to-purple-500"
}, {
  icon: Zap,
  title: "Instant New Tab",
  description: "Automatically opens filtered PDF search results in a new tab when you include 'PDF' in your search query",
  gradient: "from-orange-500 to-red-500"
}];

const Benefits = () => {
  return (
    <div className="py-24 bg-white relative">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, #3b82f6 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent mb-4">
            Streamlined PDF Discovery
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Find the exact PDF documents you need with our intelligent search enhancement
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="group">
              <div className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-gray-200 transform hover:-translate-y-2">
                {/* Icon with gradient background */}
                <div className="relative mb-6">
                  <div className={`w-16 h-16 bg-gradient-to-r ${benefit.gradient} rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                    <benefit.icon className="w-8 h-8 text-white" />
                  </div>
                  <div className={`absolute inset-0 w-16 h-16 bg-gradient-to-r ${benefit.gradient} rounded-2xl blur-lg opacity-30 group-hover:opacity-50 transition-opacity duration-300`}></div>
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-blue-700 transition-colors duration-300">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-base">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Benefits;
